const PAYOUT_POOL_STATUS_DETAILS: Record<string, string> = {
  no_attributions:
    'This payout pool was stopped because no attributions were found for the selected period. Verify that your triggers are active and tracking conversions correctly.',
};

export function getStatusDetailMessage(statusDetails: string | null): string | null {
  if (!statusDetails) return null;
  return (
    PAYOUT_POOL_STATUS_DETAILS[statusDetails] ??
    'This payout pool was stopped due to an unexpected issue. Contact support if this persists.'
  );
}
